import { render } from "./ShopOnlineTransactions.vue?vue&type=template&id=08a3f492"
import script from "./ShopOnlineTransactions.vue?vue&type=script&lang=js"
export * from "./ShopOnlineTransactions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__